import React, { useState, useEffect } from 'react';
import { Table, message } from 'antd';
import { getAllDomains, getDomainsByClient } from '../../Utils/domains/domains';
import Loading from '../../components/Shared/Loading';
import Header from "../../components/Shared/Header";
import { useSelector } from 'react-redux';


const AllDomains = () => {
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const ClientId = useSelector((state) => state.user.userInfo.user_id);
  const userRole = useSelector((state) => state.user.userRole.name);

  useEffect(() => {
    fetchDomains();
  }, []);

  const fetchDomains = async () => {
    try {
      if (userRole === 'client') {
        const response = await getDomainsByClient(ClientId);
        setDomains(response.data);
      } else {
      const response = await getAllDomains();
      setDomains(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.error('Erreur lors de la récupération des domaines:', error);
      message.error('Échec de la récupération des domaines');
      setLoading(false);
    }
  };

  const columns = [
    {
      title: 'Nom du Domaine',
      dataIndex: 'domain_name',
      key: 'domain_name',
    },
    {
      title: 'Responsable',
      dataIndex: 'domain_manager_first_name',
      key: 'manager',
      render: (_, record) => {
        if (record.domain_manager_first_name || record.domain_manager_last_name) {
          return (
            <span>
              {record.domain_manager_first_name} {record.domain_manager_last_name}
            </span>
          );
        } else {
          return <span>Non renseigné</span>;
        }
      },
    },    
    {
      title: 'Numéro de Téléphone',
      dataIndex: 'phone_number',
      key: 'phone_number',
    },
    {
      title: 'Adresse Email',
      dataIndex: 'email',
      key: 'email',
    },
    {
      title: 'Client',
      dataIndex: 'client_first_name',
      key: 'client',
      render: (_, record) => `${record.client_first_name} ${record.client_last_name}`,
    },
    {
      title: "Nombre d'Exploitations",
      dataIndex: 'total_exploitations',
      key: 'total_exploitations',
      align: 'center',
      render: (text) => (
        <div className="text-center">{text}</div>
      ),
    },
  ];

  return (
    <>
      {loading && <Loading />}
      <div className="bg-white h-full">
        <Header title="Liste des Domains" />
        <div className="h-[calc(100%-100px)]">
          <div className='p-6'>
            <Table
              dataSource={domains}
              columns={columns}
              rowKey="domain_id"
              loading={loading}
              pagination={{ pageSize: 10 }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default AllDomains;